// extracted by mini-css-extract-plugin
export default {"footerWidget":"Styles_footerWidget__VtjTb","linkText":"Styles_linkText__da2QL"};